export const PHONE_LABEL =
    upi.i18n.getTextFromKey( 'lbl-phoneWithColon', 'Phone:' );
export const FAX_LABEL =
    upi.i18n.getTextFromKey( 'lbl-faxWithColon', 'Fax:' );
export const ERROR_HEADING =
    upi.i18n.getTextFromKey( 'lbl-errorDistributorListHeading',
        'Sorry, there was problem getting the list of distributors.' );
export const ERROR_PHRASE =
    upi.i18n.getTextFromKey( 'lbl-errorDistributorListPhrase' ).replace( '%PHONE_TOLL_FREE%', upi.conf.phoneTollFree );
export const LIST_EMPTY_LABEL =
    upi.i18n.getTextFromKey( 'lbl-distributorListEmptyHeading',
        'Sorry, we were not able to find any distributors for this region.' );
export const LIST_EMPTY_PHRASE =
    upi.i18n.getTextFromKey( 'lbl-distributorListEmptyPhrase',
        'Please try selecting another region or for more information contact our customer service at %PHONE_TOLL_FREE%' )
        .replace( '%PHONE_TOLL_FREE%', upi.conf.phoneTollFree );

// todo - create i18n label in Contentful
export const DISTRIBUTORS_TITLE = upi.i18n.getTextFromKey( 'lbl-distributorsTitle', 'Distributors' );
export const DISTRIBUTORS_LIST_TITLE = upi.i18n.getTextFromKey( 'lbl-distributorsListTitle', 'Full Distributor List' );
export const SEARCH_TITLE =
    upi.i18n.getTextFromKey( 'lbl-distributorSearchTitle', 'Distributor Search' )
export const SEARCH_SUBTITLE =
    upi.i18n.getTextFromKey( 'lbl-distributorSearchSubtitle', 'Search for a distributor by name, city or postal code.' )
export const SEARCH_PLACEHOLDER =
    upi.i18n.getTextFromKey( 'lbl-distributorSearchPlaceholder', 'distributor name / postal code' )